import React from 'react';
import { Group, Text, ActionIcon, Box } from '@mantine/core';
import { FileText, Download, FileCheck, FileSpreadsheet, File, Eye } from 'lucide-react';
import type { Document } from '../types';
interface DocumentItemProps {
  document: Document;
  onDownload?: () => void;
  onView?: () => void;
}
const iconMap = {
  contract: FileCheck,
  eoi: FileText,
  'floor-plan': FileSpreadsheet,
  receipt: FileText,
  other: File
};
export function DocumentItem({
  document,
  onDownload,
  onView
}: DocumentItemProps) {
  const Icon = iconMap[document.type] || File;
  return <Box p="md" style={{
    backgroundColor: '#ffffff',
    borderRadius: 12,
    border: '1px solid #e2e8f0'
  }} data-id="element-38">
      <Group justify="space-between" align="center" wrap="nowrap" data-id="element-39">
        <Group gap="md" wrap="nowrap" style={{
        flex: 1,
        minWidth: 0
      }} data-id="element-40">
          <Box p="sm" style={{
          backgroundColor: '#f1f5f9',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }} data-id="element-41">
            <Icon size={20} color="#1a2332" data-id="element-42" />
          </Box>
          <Box style={{
          flex: 1,
          minWidth: 0
        }} data-id="element-43">
            <Text fw={600} size="sm" c="#1a2332" lineClamp={1} data-id="element-44">
              {document.name}
            </Text>
            <Text size="xs" c="#64748b" data-id="element-45">
              {document.size} •{' '}
              {new Date(document.uploadedAt).toLocaleDateString()}
            </Text>
          </Box>
        </Group>
        <Group gap="xs" data-id="element-46">
          <ActionIcon variant="light" color="blue" size="lg" radius="md" onClick={onView} aria-label={`View ${document.name}`} styles={{
          root: {
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'scale(1.1)',
              boxShadow: '0 2px 8px rgba(59, 130, 246, 0.2)'
            }
          }
        }} data-id="element-47">
            <Eye size={18} data-id="element-48" />
          </ActionIcon>
          <ActionIcon variant="light" color="green" size="lg" radius="md" onClick={onDownload} aria-label={`Download ${document.name}`} styles={{
          root: {
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'scale(1.1)',
              boxShadow: '0 2px 8px rgba(16, 185, 129, 0.2)'
            }
          }
        }} data-id="element-49">
            <Download size={18} data-id="element-50" />
          </ActionIcon>
        </Group>
      </Group>
    </Box>;
}